// example to replace the storage persistance of old redux reducer.

import { createStore } from "@stencil/store";
import { WorkoutLog } from "@sworkit/api";
import { endOfWeek, startOfWeek } from "date-fns";
import { sendEvent } from "./utils/events";

export interface WorkoutLogStore {
  recent: WorkoutLog[];
  thisWeekCount: number; //todo this is the old stat more or less, manage stats for workout logs better, in a more centralized way?
}

const initialState: WorkoutLogStore = {
  recent: [],
  thisWeekCount: 0,
};

const { state, onChange } = createStore(initialState);

onChange("recent", (recentWorkoutLogs: WorkoutLog[]) => {
  console.log("new recent workout logs", recentWorkoutLogs);
  sendEvent("onWorkoutLogsRecentUpdate", recentWorkoutLogs);
  state.thisWeekCount = getWorkoutsThisWeekCount(recentWorkoutLogs);
});

const workoutLogs = state;
export default workoutLogs;

function getWorkoutsThisWeekCount(recentWorkoutLogs: WorkoutLog[]) {
  if (!recentWorkoutLogs || recentWorkoutLogs.length === 0) return 0;
  const weekStart = startOfWeek(new Date()).getTime();
  const weekEnd = endOfWeek(weekStart).getTime();
  const workoutsThisWeek = recentWorkoutLogs.filter(
    (log) => log.timestampMillis >= weekStart && log.timestampMillis <= weekEnd,
  );
  const workoutsThisWeekCount = workoutsThisWeek.length;
  return workoutsThisWeekCount;
}
